import Hookes from '../Hookes'
import SmoothScrollManager from './'

export default class SmoothItem {
  height = 0
  top = 0

  max
  min
  ratio
  unit: string

  constructor(
    public elm: HTMLElement,
    public scrollManager: SmoothScrollManager,
    public hookes: Hookes,
    opt: { [key: string]: any } = {}
  ) {
    this.max = opt.max ? opt.max : null
    this.min = opt.min ? opt.min : null
    this.ratio = opt.ratio ? opt.ratio : 0.1
    this.unit = opt.unit ? opt.unit : 'px'
  }

  init(scrollTop: number): void {
    const rect = this.elm.getBoundingClientRect()
    this.height = rect.height
    this.top = scrollTop + rect.top
    this.elm.style.backfaceVisibility = 'hidden'
  }

  render(iwWorking: boolean): void {
    let v = 0
    if (iwWorking) {
      v = this.hookes.velocity[1] * this.ratio
      if (Math.abs(this.hookes.acceleration[1]) < 0.01) {
        this.hookes.velocity[1] = this.hookes.anchor[1]
      }
      if (this.min) v = Math.max(v, this.min)
      if (this.max) v = Math.min(v, this.max)
    }
    this.elm.style.transform = `translate3D(0, ${v}${this.unit}, 0)`
  }
}
